import { render, staticRenderFns } from "./LineCheckFollowUpRules.vue?vue&type=template&id=4128782c&"
import script from "./LineCheckFollowUpRules.vue?vue&type=script&lang=ts&"
export * from "./LineCheckFollowUpRules.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/components/admin/line-check.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports